angular.module('cvsApp').service('orderSummaryService',['networkService', 'xdrService', 'configManager', 'orderSummaryModel','cvsAppData', function (NS, XS,CM, OSM,CAD) {
   	
	function orderSummary (){
		this.orderSummaryData = function(callBackSuccess, shipmentNumber, numberOfShipment){
			//get url
            var tokenId= CAD.getTokenId();
            var tokenType= CAD.getTokenType();
			var apikey = CAD.getApiKey();
			var url = CM.getApiUrlWithApikeyV2('GET_ORDER_SUMMARY_v2', tokenId, CAD.getTokenType());
			// var url = CM.getAGPAPIUrl('AGP_ORDER_SUMMARY');
			url = CVS.Config.serviceHost[cvsUtility.queryMap.env]+"SPLAGPv1/order/getOrderSummary/v2";
			if (cvsUtility.queryMap.env === 'local') {
				url = CVS.Config.serviceHost[cvsUtility.queryMap.env] + "specialty/SPLAGPv1/order/getOrderSummary/v2";
			}
			if(url === "URL_ERROR"){

			}else{

				//var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');

			   /*
				* SPEC-1049 UI to consume new order summary service
				* SPEC-1050 UI to consume new order tracking service
			   */

				// if(cvsUtility.queryMap.env === 'local'){
				// 	if(shipmentNumber){
				// 		url = url+'/'+shipmentNumber
				// 	}
				// 	if(numberOfShipment){
				// 		url = url+'/recentorder';
				// 	}
				// 	else{
				// 		url = url
				// 	}
				// }

				var request = {url:url,
							header:{
								"Content-Type": "application/json",
								"Accept":"application/json"
							},
							data:requestBody(shipmentNumber, numberOfShipment),
							onSuccess:callBackSuccess
						}
				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(url, "", xdrSuccess);

					function xdrSuccess (data) {
						OSM.setResponse(data);
						callBackSuccess(OSM.getResponse());
					}
				}
				else {
					var promise = NS.post(request);	
					promise.then(function(data, c, d){
						
						OSM.setResponse(data.data);
						callBackSuccess(OSM.getResponse());

					}, function(reason){
						callBackSuccess(NS.httpError(reason));
					});
				} 
			}
							
		}

			/*
			* SPEC-1049 UI to consume new order summary service
			* SPEC-1050 UI to consume new order tracking service
			*/

		var requestBody = function(shipmentNumber, numberOfShipment){
			// var tokenId =  CAD.getTokenId();
			// var tokenType = CAD.getTokenType();
			var tokenId, tokenType;
			try{
				tokenId = CAD.getTokenId() ? CAD.getTokenId() : (guestTokenID || cvsUtility.queryMap.tokenId);
				tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((guestTokenID) ? 'Guest' : 'Login');
			}
			catch(ex){
				tokenId = guestTokenID || cvsUtility.queryMap.tokenId;
				tokenType = (guestTokenID) ? 'Guest' : 'Login';
			}
			var apikey = CAD.getApiKey();
			var requestDetails = {};
            if(shipmentNumber){
                requestDetails.shipmentNumber = shipmentNumber;
            }
            if(numberOfShipment){
                requestDetails.NumberOfShipment = numberOfShipment.toString();
            }
			return {"getOrderSummaryRequest": {"header": {
                "serviceContext":    {
                    "appName": cvsUtility.queryMap.mobileAppStyle? 'SPL_APP' : 'SPL_WEB',
                    "lineOfBusiness": "Specialty",
					"channelName": cvsUtility.queryMap.channel,
					"responseFormat": "JSON",
                    "tokenID": tokenId,
					"tokenType": CM.getAGPTokenType(tokenType),
					"type":"SPLSBMS",
					"bkAppName":"orderService"
                },
                "securityContext": {
					"apiKey": apikey,
					"securityType": "apiKey"
				}
			},
			"details": requestDetails
		}}


        }


		this.setResponse = function(data){
			PQM.setResponse(data);		
		}	

		this.getResponse = function(){				
			return PQM.getResponse();		
		}	
	
	}
	
	return new orderSummary();	
}]);
